<template>
    <q-page class="flex flex-center"> </q-page>
</template>

<style></style>

<script>
export default {
    name: "HelloWorld",
};
</script>
